var map = {
	"./contact/onRowDelete": 883,
	"./cpo/onRowDelete": 884,
	"./customer/onRowDelete": 885,
	"./forwarderPo/onRowDelete": 886,
	"./incomingInvoice/onRowDelete": 887,
	"./incomingPayment/onRowDelete": 888,
	"./outgoingInvoice/onRowDelete": 889,
	"./outgoingPayment/onRowDelete": 890,
	"./outgoingQuote/onRowDelete": 891,
	"./product/onRowDelete": 892,
	"./receiving/onRowDelete": 893,
	"./shipping/onRowDelete": 894,
	"./spo/onRowDelete": 363,
	"./spoSched/onRowDelete": 895,
	"./vatDeductRecord/onRowDelete": 896,
	"./vendor/onRowDelete": 897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 882;